
import { createSlice } from "@reduxjs/toolkit"

const userSlice = createSlice({
    name: "user",
    initialState: {
        currentUser: null,
        isFetching: false,
        error: null
    },
    reducers: {
        userStart: (state) => {
            state.isFetching = true
        },
        userFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
        },
        loginSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.currentUser = action.payload
        },
        loginFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
            state.currentUser = null
        },
        logoutSuccess: (state) => {
            state.isFetching = false
            state.error = null
            state.currentUser = null
        },
        getUserSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.users = action.payload
        },
        deleteUserSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.users.splice(
                state.users.findIndex((item) => item._id === action.payload),
                1
            )
        },
        updateUserSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.users[state.users.findIndex((item) => item._id === action.payload.id)] = action.payload.user
        },
        createUserSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.users.push(action.payload)
        }
    }
})

export const {
    userStart,
    userFailure,
    loginSuccess,
    loginFailure,
    logoutSuccess,
    getUserSuccess,
    deleteUserSuccess,
    updateUserSuccess,
    createUserSuccess
} = userSlice.actions
export default userSlice.reducer
